import { render, staticRenderFns } from "./BidResultList.vue?vue&type=template&id=670f2fdb&scoped=true&"
import script from "./BidResultList.vue?vue&type=script&lang=js&"
export * from "./BidResultList.vue?vue&type=script&lang=js&"
import style0 from "./BidResultList.vue?vue&type=style&index=0&id=670f2fdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f2fdb",
  null
  
)

export default component.exports